import { useState } from 'react';

const BeforeYouBook = ({ isOpen, onToggle, className = '' }) => {
  const [activeTab, setActiveTab] = useState('baggage');

  if (!isOpen) return null;

  return (
    <div className={`flex flex-wrap -mx-4 border-t border-dashed ${className}`}>
      <div className="w-full px-4 border-b border-dashed">
        <div>
          <div>
            <ul className="flex list-none p-0 m-0 border-b border-gray-200">
              <li className="mr-5">
                <a
                  href="#"
                  className={`block px-4 py-2 no-underline border-b-2 transition-all ${
                    activeTab === 'baggage' 
                      ? 'text-blue-600 border-yellow-400' 
                      : 'text-gray-600 border-transparent'
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveTab('baggage');
                  }}
                >
                  Baggage
                </a>
              </li>
              <li className="mr-5">
                <a
                  href="#"
                  className={`block px-4 py-2 no-underline border-b-2 transition-all ${
                    activeTab === 'terms' 
                      ? 'text-blue-600 border-yellow-400' 
                      : 'text-gray-600 border-transparent'
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveTab('terms');
                  }}
                >
                  Terms & Conditions
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="w-full px-4">
        {activeTab === 'baggage' && (
          <div className="py-2">
            <div className="max-h-96 overflow-y-scroll border-b-2 border-yellow-400 p-2">
              <div className="w-full px-4">
                <h4 className="text-base font-bold mb-4 text-gray-800">Baggage Allowance Information</h4>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  Thank you for choosing Jetscanner360 for your travel needs. We aim to provide you with a comfortable and hassle-free journey. To ensure a smooth experience, here is important information regarding our baggage allowance policy.
                </p>

                <b className="text-sm text-gray-800">1. Carry-On Baggage:</b>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  Passengers are generally permitted to carry two pieces of carry-on baggage, each weighing up to 7 kg (15 lbs), with dimensions not exceeding 56 cm x 36 cm x 23 cm (22 in x 14 in x 9 in). Please note that these allowances are subject to individual Jetscanner360 policies, and additional restrictions may apply based on specific routes or aircraft types. Kindly refer to your e-ticket or contact our customer service for detailed information.
                </p>

                <b className="text-sm text-gray-800">2. Checked Baggage:</b>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  Passengers enjoy a higher checked baggage allowance. The specifics may vary, but it typically ranges from 30 kg to 40 kg (66 lbs to 88 lbs) per piece, with multiple pieces allowed. Excess baggage charges may apply if your checked baggage exceeds the permitted weight or size limits. To avoid any inconvenience, we advise reviewing your baggage allowance in advance and arranging for additional baggage if required.
                </p>

                <b className="text-sm text-gray-800">3. Special Baggage:</b>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  For certain items such as sporting equipment, musical instruments, or fragile items, we offer special allowances and handling procedures. Please contact our customer service or visit our website for detailed information on how to transport specific types of special baggage.
                </p>

                <b className="text-sm text-gray-800">4. Infants and Children:</b>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  Infants (under two years of age) traveling on your lap usually have a separate baggage allowance, which varies by Jetscanner360. Child passengers (two years and above) typically receive the same baggage allowance as adults. We recommend verifying the applicable baggage allowances for infants and children when making your reservation or contacting our customer service for further assistance.
                </p>

                <b className="text-sm text-gray-800">5. Additional Baggage Services:</b>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  Our Jetscanner360 offers additional services such as pre-paid extra baggage, priority baggage handling, and oversized/overweight baggage options. In most circumstances charges are waived. You can find more information about these services on our website or by reaching out to our customer service team.
                </p>

                <b className="text-sm text-gray-800">6. Security Regulations:</b>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  Please be aware that there are security regulations and restrictions on carrying certain items in both carry-on and checked baggage. Prohibited items include but are not limited to firearms, explosives, flammable materials, and sharp objects. We strongly advise familiarizing yourself with the latest security guidelines provided by relevant authorities to ensure compliance and a smooth journey. Note: The baggage allowance information provided here is intended as a general guideline. Specific allowances may vary depending on the fare class, ticket type, destination, and any special promotions. We encourage you to refer to your e-ticket or contact our customer service for the most accurate and up-to-date information. For any further inquiries or assistance, please visit our website or contact our customer service helpline, available 24/7. Thank you for choosing Jetscanner360. We wish you a pleasant journey!
                </p>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'terms' && (
          <div className="py-2">
            <div className="max-h-96 overflow-y-scroll border-b-2 border-yellow-400 p-4">
              <div className="w-full px-4">
                <h4 className="text-base font-bold mb-4 text-gray-800">Terms and Conditions for Private Jet Passengers</h4>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  These terms and conditions ("Terms") outline the rights and responsibilities of passengers ("Passenger" or "You") when traveling with our Jetscanner360 ("Jetscanner360" or "We"). By purchasing a ticket and/or boarding our aircraft, you agree to comply with these Terms. Please read them carefully before your journey.
                </p>

                <b className="text-sm text-gray-800">1. Ticketing and Reservations:</b>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>1.1</b> All tickets are subject to availability and applicable fares. Prices may vary based on factors such as destination, date, and time of travel.
                </p>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>1.2</b> Tickets are non-transferable, and changes to passenger details may incur additional fees.
                </p>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>1.3</b> You must ensure that the information provided during ticket purchase and reservation is accurate, including your full name, contact details, and travel documents.
                </p>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>1.4</b> Failure to comply with ticketing and reservation requirements may result in the cancellation of your reservation or boarding denial.
                </p>

                <b className="text-sm text-gray-800">2. Check-In and Boarding:</b>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>2.1</b> You must check in for your flight within the specified time frame, which may vary depending on the departure airport and flight destination.
                </p>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>2.2</b> You are responsible for obtaining all necessary travel documents, such as a valid passport, visa, and health certificates. Failure to provide required documents may result in denied boarding.
                </p>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>2.3</b> Boarding gates close prior to the scheduled departure time, and you must be present at the gate before this deadline. We reserve the right to deny boarding if you arrive after the gate closure.
                </p>

                <b className="text-sm text-gray-800">3. Baggage:</b>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>3.1</b> Baggage allowances, including the number, weight, and dimensions, may vary depending on the fare class, flight route, and cabin class. Excess baggage fees may apply.
                </p>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>3.2</b> You are responsible for ensuring that your baggage is properly packed and labelled with your name and contact details.
                </p>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>3.3</b> Restricted items, such as hazardous materials, weapons, and flammable substances, are prohibited in both checked and carry-on baggage. Please refer to our website or contact us for detailed information on restricted items.
                </p>

                <b className="text-sm text-gray-800">4. Flight Changes and Cancellations:</b>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>4.1</b> Jetscanner360 schedules, flight routes, and departure times are subject to change without prior notice. We will make reasonable efforts to notify you of any changes.
                </p>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>4.2</b> In the event of flight cancellations or delays, we will provide alternative arrangements or refunds as per our policy and regulatory requirements.
                </p>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>4.3</b> We recommend that you provide accurate contact information during reservation to ensure timely communication regarding flight changes or cancellations.
                </p>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>4.4</b> Cancellation Fee - $ 250
                </p>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>4.5</b> Agency Fee - 5 %
                </p>

                <b className="text-sm text-gray-800">5. Passenger Conduct:</b>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>5.1</b> Passengers must comply with all applicable laws, regulations, and security procedures of the countries of departure, arrival, and transit.
                </p>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>5.2</b> You must not engage in disruptive or illegal behavior, including but not limited to harassment, violence, or interference with the crew's duties.
                </p>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>5.3</b> Smoking, including the use of electronic cigarettes, is prohibited on all flights.
                </p>

                <b className="text-sm text-gray-800">6. Flight Safety:</b>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>6.1</b> Passengers must follow the instructions of the flight crew, particularly during safety demonstrations, takeoff, landing, and emergency situations.
                </p>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>6.2</b> The use of electronic devices may be restricted during certain phases of the flight. Please comply with the crew's instructions regarding device usage.
                </p>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>6.3</b> We reserve the right to refuse boarding or remove passengers who pose a threat to flight safety or refuse to comply with safety regulations.
                </p>

                <b className="text-sm text-gray-800">7. Liability:</b>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>7.1</b> Jetscanner360 liability for personal injury, loss, or damage to baggage is limited as per international conventions and applicable laws.
                </p>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>7.2</b> We are not responsible for any indirect, consequential, or incidental damages resulting from flight delays, cancellations, or changes.
                </p>

                <b className="text-sm text-gray-800">8. Privacy and Data Protection:</b>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>8.1</b> We will collect and process your personal information in accordance with applicable privacy laws and our Privacy Policy.
                </p>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>8.2</b> Your personal data may be shared with third parties, such as immigration authorities and security agencies, as required by law or for the purpose of your travel.
                </p>

                <b className="text-sm text-gray-800">9. Governing Law and Jurisdiction:</b>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>9.1</b> These Terms shall be governed by and construed in accordance with the laws of [Jurisdiction].
                </p>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>9.2</b> Any disputes arising from these Terms shall be subject to the exclusive jurisdiction of the courts of [Jurisdiction].
                </p>

                <b className="text-sm text-gray-800">10. Amendments to Terms:</b>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>10.1</b> We reserve the right to modify or update these Terms at any time. The most recent version will be available on our website.
                </p>
                <p className="text-sm leading-relaxed text-gray-700 mb-2">
                  <b>10.2</b> Any changes to these Terms will become effective upon posting on our website.
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BeforeYouBook;
